import { LoadableLazy } from '@confluence/loadable';

export const SpacesEmptyStateLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SpacesEmptyState" */
				'../components/SpacesEmptyState.tsx'
			)
		).SpacesEmptyState,
});
